// Leitor de código de barras USB no Novo Pedido do Delivery (pedido do dono,
// 29/09/2026: "o delivery também deve aceitar o código de barra"). Mesma escuta
// e mesmas regras do Balcão — hooks/useLeitorCodigoBarras e lib/codigoBarras.
import { toast } from "sonner";

import { useLeitorCodigoBarras } from "../../hooks/useLeitorCodigoBarras";
import { avisoLeituraNaoEncontrada, identificarLeitura, itemPelaEtiqueta } from "../../lib/codigoBarras";

/**
 * `addToCart(produto, quantidade, observacao)` e `abrirProduto(produto)` são os
 * do Novo Pedido (pages/Delivery.js → CardapioPopup). O carrinho de lá soma
 * `sale_price × quantity`, por isso a etiqueta mexe em `sale_price`.
 * `precoDoProduto(produto)` → `{ preco, promocional }`: o preço do clique no
 * produto, com a promoção ativa (30/09/2026). `cart`: o carrinho atual, para
 * avisar quando a mesma etiqueta se repete.
 */
export function useLeitorNovoPedido({ ativo, products, allProducts, cart, addToCart, abrirProduto, precoDoProduto }) {
  const lerCodigo = (codigo) => {
    const r = identificarLeitura(codigo, products);
    if (r.tipo === "nao_encontrado") { toast.error(avisoLeituraNaoEncontrada(r, allProducts, "no Delivery")); return; }
    const p = r.produto;
    if (p.available === false) { toast.error(`${p.name} está esgotado`); return; }
    if (r.tipo === "balanca") {
      // A mesma etiqueta pode se repetir (Chiquinho Carnes, 31/10/2026): dois
      // pacotes com o mesmo peso dão o mesmo código (produto + valor, sem número
      // de série). Entra como outra linha; só avisa, para o atendente conferir.
      if ((cart || []).some((i) => i.etiqueta_balanca && i.etiqueta_balanca === r.codigo)) {
        toast.info(`Etiqueta repetida: mais um ${p.name} de R$ ${Number(r.total).toFixed(2).replace(".", ",")}`);
      }
      // Etiqueta (decisão do dono, 30/09/2026): vale o valor e o peso impressos,
      // sem promoção — e o item vai marcado como não promocional.
      const item = { ...p, ...itemPelaEtiqueta(p, r.total, r.codigo), is_promotional: false };
      addToCart(item, item.quantity, item.observation);
      return;
    }
    // Bipou = adicionou, mesmo com etapas (igual ao Balcão). Só pizza e combo
    // abrem a montagem (a pizza tem o fluxo dela).
    if (p.product_type === "pizza" || p.product_type === "combo") { abrirProduto(p); return; }
    // Embalagem: entra com o preço promocional, igual ao clique no produto.
    const { preco, promocional } = precoDoProduto ? precoDoProduto(p) : { preco: p.sale_price || 0, promocional: false };
    addToCart({ ...p, sale_price: preco, is_promotional: promocional }, 1);
  };
  useLeitorCodigoBarras({ ativo, onLeitura: lerCodigo });
}
